var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPleatsFrench(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_4874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 12.3695C34.0421 9.33812 43.6276 9.0847 61.4261 12.3695",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.248 59.501C13.448 32.7485 13.1539 13.8027 15.6919 9.75195C18.5717 13.7293 19.9734 16.1391 21.2777 21.4473C20.6605 35.9958 20.5901 44.4017 20.5795 59.501",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4196 59.3266C23.7253 42.9739 23.1966 34.2304 21.2776 21.6221",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8662 9.7526C19.5247 7.52055 21.6429 6.26888 30.0054 3.99219",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7903 59.501C65.5903 32.7485 65.8845 13.8027 63.3465 9.75195C60.4666 13.7293 59.0649 16.1391 57.7606 21.4473C58.3778 35.9958 58.4482 44.4017 58.4589 59.501",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6187 59.3266C55.3131 42.9739 55.8417 34.2304 57.7607 21.6221",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1709 9.7526C59.5124 7.52055 57.3942 6.26888 49.0317 3.99219",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4021 0.5C30.6715 1.79061 30.3524 2.61458 30.0056 4.34027C37.8343 6.65594 41.82 6.26189 49.0324 3.99116C48.3921 2.54623 48.0412 1.79111 46.9377 0.5C41.1326 2.07309 37.7183 2.04593 31.4021 0.5Z",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9583 22.8436C29.9866 18.9178 30.3224 16.4943 30.0056 11.3228",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0203 22.8441C48.9919 18.9183 48.6561 16.4948 48.9729 11.3232",
    stroke: "#999999",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_4874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 59,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPleatsFrench);
export default __webpack_public_path__ + "static/media/pleats_french.b144f1a8091b2cd7449841caa0da539a.svg";
export { ForwardRef as ReactComponent };